import * as React from 'react'

import { TColorKey, TSpecialColorKey } from '~theme/typings'
import { IconLine } from '~ui/components/IconLine/IconLine'
import { IconAlertFill } from '~ui/components/icons/specific/IconAlert'
import { IconCheckMarkCircleFill } from '~ui/components/icons/specific/IconCheckMark'
import { Box } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren & {
  /**
   * background color of the Box
   */
  bgColor?: TColorKey
  /**
   * indicates which icon to display
   */
  status: Extract<TSpecialColorKey, `error` | `success`>
  /**
   * provided text to render
   */
  validationMessage: React.ReactNode
}

export const AddonValidationMessage: React.FC<TProps> = ({
  bgColor = `bgColors.messages`,
  status = `error`,
  validationMessage,
}) => {
  return (
    <Box
      bgColor={bgColor}
      padding={{ vertical: `smallMedium`, horizontal: `extraSmall` }}
      radius={`small`}
    >
      <IconLine
        icon={status === `error` ? IconAlertFill : IconCheckMarkCircleFill}
        spacing={`extraSmall`}
        iconColor={`specialColors.${status}`}
        iconSize={`1.5rem`}
        iconAlign={`center`}
        iconPartForcedWidth={`3rem`}
        children={<Text fontSize={`s14`}>{validationMessage}</Text>}
      />
    </Box>
  )
}
